import {setSlideTransition, SLIDE_PROPS} from './slide';

export default function slideDown(el, { speed = 300 } = {}, display = 'block') {
  const dup = createInvisibleDuplicate(el, display);
  el.parentNode.appendChild(dup);

  setupSlideDown(el, speed, display);

  setTimeout(function() {
    const height = `${dup.offsetHeight}px`;
    const computedStyle = getComputedStyle(dup);
    el.parentNode.removeChild(dup);
    SLIDE_PROPS.forEach(prop => el.style[prop] = computedStyle[prop]);
    el.style.maxHeight = height;
  }, 0);

  setTimeout(function() {
    SLIDE_PROPS.concat('transition', 'overflow').forEach(prop => el.style[prop] = '');
  }, speed);
}

function createInvisibleDuplicate(el, display) {
  const dup = el.cloneNode(true);
  dup.style.position = 'absolute';
  dup.style.left = '-10000';
  dup.style.visibility = 'hidden';
  dup.style.display = display;
  return dup;
}

function setupSlideDown(el, speed, display) {
  // ['maxHeight', 'paddingTop'] => 'max-height 300ms, padding-top 300ms'
  setSlideTransition(el, speed);
  el.style.overflow = 'hidden';
  el.style.display = display;
  SLIDE_PROPS.forEach(prop => el.style[prop] = 0);
}
